import axios from "axios";
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_API_URL;

class ParcelOrderService {
  index(business_id = null) {
    const params = business_id ? { business_id } : {};
    return axios.get(API_URL + "parcel_orders", { headers: authHeader(), params }).then(response => {
        return response.data;
    });
  }

  create(user_id, parcel_id, price_id, pickup_location, quantity, collection_date, departure_province, destination_province, departure_town, destination_town, drop_off_location = null, receiver_full_name = null, receiver_cellphone = null, parcel_description = null, number_of_items = null, collection_invoice_number = null) {
    const order = {
      user_id, parcel_id, price_id, pickup_location, quantity,
      collection_date, departure_province, destination_province,
      departure_town, destination_town
    };

    if (drop_off_location) order.drop_off_location = drop_off_location;
    if (receiver_full_name) order.receiver_full_name = receiver_full_name;
    if (receiver_cellphone) order.receiver_cellphone = receiver_cellphone;
    if (parcel_description) order.parcel_description = parcel_description;
    if (number_of_items) order.number_of_items = number_of_items;
    if (collection_invoice_number) order.collection_invoice_number = collection_invoice_number;

    return axios
      .post(API_URL + "parcel_orders", { parcel_order: order }, {headers: authHeader()})
      .then(response => {
        return response.data;
      });
  }

  createForBusiness(business_id, user_id, parcel_id, price_id, pickup_location, quantity, collection_date, departure_province, destination_province, departure_town, destination_town, departure_address, destination_address, receiver_full_name, receiver_cellphone, parcel_description, number_of_items, collection_invoice_number) {
    const payload = {
      business_id, user_id, parcel_id, price_id, pickup_location, quantity, collection_date,
      departure_province, destination_province, departure_town, destination_town,
      drop_off_location: destination_address,
    };
    if (receiver_full_name) payload.receiver_full_name = receiver_full_name;
    if (receiver_cellphone) payload.receiver_cellphone = receiver_cellphone;
    if (parcel_description) payload.parcel_description = parcel_description;
    if (number_of_items) payload.number_of_items = number_of_items;
    if (collection_invoice_number) payload.collection_invoice_number = collection_invoice_number;

    return axios
      .post(API_URL + "parcel_orders", { parcel_order: payload }, { headers: authHeader() })
      .then(response => response.data);
  }

  bulkCreate(parcelOrders) {
    return axios
      .post(API_URL + "parcel_orders/bulk", { parcel_orders: parcelOrders }, { headers: authHeader() })
      .then(response => response.data);
  }

  findOrder(parcel_reference){
    return axios.get(API_URL + "parcel_orders/" + parcel_reference, {headers: authHeader()})
    .then(response => {
      return response.data;
    });
  }

  updateOrderStatus(parcel_order_id, status) {
    return axios
      .patch(API_URL + "parcel_orders/" + parcel_order_id, { parcel_order: { status: status }
      }, {headers: authHeader()})
      .then(response => {
        return response.data;
      });
  }

  parcel_order_fulfillments(){
    return axios.get(API_URL + "parcel_order_fulfilments", { headers: authHeader() }).then(response => {
      return response.data;
  });
  }

  generateInvoice(order_id) {
    return axios.post(API_URL + "parcel_orders/" + order_id + "/generate_invoice", {}, { headers: authHeader() })
      .then(response => response.data);
  }

  generateMonthlyInvoice(business_id) {
    return axios.post(API_URL + "parcel_orders/generate_monthly_invoice", { business_id }, { headers: authHeader() })
      .then(response => response.data);
  }
}

export default new ParcelOrderService();